import React, { Component } from "react";
import Joyride from "react-joyride";
import { dispatch } from '@rematch/core';

class UITour extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      run: true
    };

    this.handleJoyrideCallback = this.handleJoyrideCallback.bind(this);
  }

  async handleJoyrideCallback(data) {
    const { status, index } = data;
    if (status === "ready" && index === 0) {
      localStorage.removeItem('showUiTour');
    }
  }


  render() {
    const steps = [
      // {
      //   title: "Navigating Accounts",
      //   target: "#create-account",
      //   content:  <div>
      //                 <div style={{marginBottom: '10px'}}>
      //                     <p style={{fontSize: '10px'}}>Congratulations on creating your account! To navigate to another users account you can click the account button in the bar at the top to show the accounts you can access.</p>
      //                 </div>
      //                 <div>
      //                   <video
      //                     className="rounded-md border border-blue-500"
      //                     style={{ width: "460px", height: "260px" }}
      //                     controls
      //                     autoPlay
      //                     muted
      //                   >
      //                     <source
      //                       src="https://res.cloudinary.com/dooajkrko/video/upload/v1741164718/uitour/Navigating_Account_and_Workspace_kwa6jq.mp4"
      //                       type="video/mp4"
      //                     />
      //                     Your browser does not support the video tag.
      //                   </video>
      //                 </div>
      //             </div>,
      //             disableBeacon: true
      // },
      {
        title: "Generating a Playbook",
        target: "#create-playbook",
        content:  <div>
                    <div style={{marginBottom: '10px'}}>
                        <p style={{fontSize: '10px'}}>To get started in Aspenify you can generate a Playbook. You can do this by hovering the highlighted plus button and selecting the <b>Generate</b> option.</p>
                    </div>
                    <div>
                      <video
                        className="rounded-md border border-blue-500"
                        style={{ width: "460px", height: "260px" }}
                        controls
                        autoPlay
                        muted
                      >
                        <source
                          src="https://res.cloudinary.com/dooajkrko/video/upload/v1741164718/uitour/Generate_Playbook_qcl46a.mp4"
                          type="video/mp4"
                        />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  </div>,
                  disableBeacon: true
      }
    ];

    return (
      <div style={{"line-height": 0, "text-align": "left"}}>
        <Joyride
          steps={steps}
          size={5}
          run={this.state.run}
          // continuous
          showProgress
          callback={this.handleJoyrideCallback}
          floaterProps={{
            disableAnimation: false,
          }}
          showSkipButton={true}
          hideCloseButton={true}
          disableCloseOnEsc={true}
          disableOverlayClose={true}
          disableBeacon={true} // Disable beacons for all steps
          styles={{
            beaconInner: { backgroundColor: "#1f7fcd" },
            beaconOuter: { backgroundColor: "#1f7fcd" },
            buttonBack: { color: "#1f7fcd", fontSize: "small" },
            buttonClose: { color: "#1f7fcd", fontSize: "small" },
            buttonNext: { 
              backgroundColor: "#1f7fcd", 
              color: "#fff",
              fontSize: "small"
            },
            buttonSkip: { color: "#1f7fcd" },
            options: {
              primaryColor: "#1f7fcd",
              width: 600
            },
            tooltip: {
              padding: '6px',
              maxWidth: 'min-content'
            },
            tooltipContainer: {
              lineHeight: 1,
              textAlign: 'left'
            },
            tooltipFooter: {
              marginTop: 0
            },
            tooltipTitle: {},
            tooltipContent: {
              padding: '10px 0px'
            }
          }}
        />
      </div>
    );
  }
}

export default UITour;